import { Card, CardContent, CardHeader, CardTitle } from "@/shared/ui/card";
import { Badge } from "@/shared/ui/badge";
import { ScrollArea } from "@/shared/ui/scroll-area";
import { Bell, AlertTriangle, AlertCircle, Info } from "lucide-react";

export function AlertsWidget() {
  const alerts = [
    {
      id: 1,
      type: "critical",
      title: "Line 2 Downtime",
      message: "Assembly Line 2 stopped - Sensor malfunction",
      time: "5 min ago",
      location: "Production Hall A",
    },
    {
      id: 2,
      type: "warning",
      title: "Material Low Stock",
      message: "Component X-2047 below reorder point",
      time: "15 min ago",
      location: "Warehouse B",
    },
    {
      id: 3,
      type: "info",
      title: "Shift Change",
      message: "Evening shift starting in 30 minutes",
      time: "30 min ago",
      location: "All Departments",
    },
    {
      id: 4,
      type: "warning",
      title: "Quality Alert",
      message: "Increased defect rate on Line 3",
      time: "45 min ago",
      location: "Quality Control",
    },
    {
      id: 5,
      type: "critical",
      title: "Equipment Maintenance Due",
      message: "Press #4 preventive maintenance overdue",
      time: "1 hour ago",
      location: "Stamping",
    },
  ];

  const getAlertIcon = (type: string) => {
    switch (type) {
      case "critical":
        return <AlertTriangle className="h-4 w-4 text-destructive" />;
      case "warning":
        return <AlertCircle className="h-4 w-4 text-warning" />;
      case "info":
        return <Info className="h-4 w-4 text-chart-2" />;
      default:
        return <Bell className="h-4 w-4" />;
    }
  };

  const getAlertBadge = (type: string) => {
    switch (type) {
      case "critical":
        return <Badge variant="destructive" className="text-xs">Critical</Badge>;
      case "warning":
        return <Badge variant="outline" className="text-xs text-warning border-warning">Warning</Badge>;
      case "info":
        return <Badge variant="outline" className="text-xs text-chart-2 border-chart-2">Info</Badge>;
      default:
        return null;
    }
  };

  return (
    <Card className="h-full flex flex-col">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <CardTitle className="text-base flex items-center gap-2">
            <Bell className="h-4 w-4" />
            Active Alerts
          </CardTitle>
          <Badge variant="outline">{alerts.length} alerts</Badge>
        </div>
      </CardHeader>
      <CardContent className="flex-1 overflow-hidden">
        <ScrollArea className="h-full pr-4">
          <div className="space-y-3">
            {alerts.map((alert) => (
              <div
                key={alert.id}
                className="flex gap-3 p-3 rounded-lg border bg-card hover:bg-accent/50 transition-colors cursor-pointer"
              >
                <div className="mt-0.5">{getAlertIcon(alert.type)}</div>
                <div className="flex-1 space-y-1 min-w-0">
                  <div className="flex items-start justify-between gap-2">
                    <p className="text-sm font-medium leading-tight">{alert.title}</p>
                    {getAlertBadge(alert.type)}
                  </div>
                  <p className="text-xs text-muted-foreground line-clamp-2">{alert.message}</p>
                  <div className="flex items-center gap-2 text-xs text-muted-foreground">
                    <span>{alert.location}</span>
                    <span>•</span>
                    <span>{alert.time}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
